import React, { useState, useEffect, Fragment } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  CssBaseline,
  Modal,
  Typography,
  Grid,
  Button,
  useTheme,
  TextField,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  Menu,
  MenuItem,
  Fade,
  InputLabel,
  Select,
  Autocomplete,
} from "@mui/material";

import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import {
  getTokenRefresh,
  verifyExpireTokenRefresh,
} from "../../../../helpers/token/refreshToken";
import SnackBar from "../../../../components/snackbar/SnackBar";
import { tokens } from "../../../../theme";
import { modalStyle } from "./DriverStyle";
import {
  createDriverPayment,
  deleteDriverApi,
  getDriverAndVehicle,
} from "../../../../api/users/driver/driver";
import {
  getFixedPayments,
  updatePaymentBooking,
  updatePaymentBookingNow,
} from "../../../../api/booking/bookingNow";
import { convertDate } from "../../../../helpers/date/convertDate";
import { DataGrid, esES } from "@mui/x-data-grid";
//sidebar
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme as themeStyles } from "@mui/material/styles";
import Sidebar from "../../../../components/sidebar/Sidebar";
import { getAdvanceCashOrder } from "../../../../api/booking/advance";

const DriverHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const themeSidebar = themeStyles();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));

  const [drivers, setDrivers] = useState([]);

  const [bookings, setBookings] = useState(null);
  const [bookSort, setBookSort] = useState(null);

  const [UID, setUID] = useState("");
  const [STATUS, setSTATUS] = useState("");
  const [FULLNAME, setFULLNAME] = useState("");
  const [DEBT, setDEBT] = useState(0);
  const [pay, setPay] = useState(0);
  const location = useLocation();
  const driverName = location.state.fullname;

  const driverStatus = {
    1: "Activo",
    2: "Suspendido",
    3: "Eliminado",
  };

  useEffect(() => {
    const listBooking = async () => {
      try {
        const token = getTokenRefresh();
        const commissionPayment = await getFixedPayments(token, id);
        console.log(commissionPayment.data);
        let count = 0;

        setBookings([]);
        Object.values(commissionPayment.data).map((booking) => {
          if (booking.booking_type) {
            setBookings((oldData) => [...oldData, booking]);
          }
        });
      } catch (error) {
        console.log(error);
      }
    };
    listBooking();
  }, []);

  useEffect(() => {
    const driversData = async () => {
      const verify = verifyExpireTokenRefresh();
      if (verify) return console.log("no token");

      const token = getTokenRefresh();
      try {
        const response = await getDriverAndVehicle(token);
        setDrivers(response?.data);
      } catch (error) {
        console.log(error);
      }
    };
    driversData();
  }, []);

  useEffect(() => {
    if (bookings) {
      const compareByDate = (a, b) => {
        const dateB = convertDate(b.date, b.time);
        const dateA = convertDate(a.date, a.time);
        return dateB - dateA;
      };
      setBookSort([]);
      console.log(bookings);
      Object.values(bookings)
        .sort(compareByDate)
        .map((book, index) => {
          book.index = index + 1;
          setBookSort((oldData) => [...oldData, book]);
        });
    }
  }, [bookings]);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const [igv, setIgv] = useState(0);

  const [selectBooking, setSelectBooking] = useState(null);
  const [advanceList, setAdvanceList] = useState([]);

  const listState = ["PENDIENTE", "PAGADO", "CANCELADO"];
  const [driverStatus1, setDriverStatus] = useState("");
  const [driverSelect, setDriverSelect] = useState(null);

  const getPaymentsList = async (orderNumber) => {
    const resp = await getAdvanceCashOrder(orderNumber);
    return resp;
  };

  const setBookingBusinessData = async () => {
    const order = bookings.filter((book) => {
      if (book.id === UID) return true;
      return false;
    });

    if (order.length > 0) {
      setSelectBooking(order[0]);
      const resp = await getPaymentsList(order[0].order_number);
      console.log("advanceList", resp);
      setAdvanceList(resp.data.resp);
    }

    console.log(order);
  };

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #000",
    boxShadow: 20,
    width: 300,
    p: 2,
  };

  const columns = [
    { field: "index", headerName: "ID", width: 50 },
    {
      headerName: "Numero",
      field: "order_number",
      type: "string",
      headerAlign: "left",
      align: "left",
      width: 90,
    },
    {
      headerName: "FECHA",
      field: "date",
      width: 80,
    },
    {
      headerName: "HORA",
      field: "time",
      width: 70,
    },
    {
      headerName: "ORIGEN",
      field: "origin_name",
      width: 200,
      renderCell: ({
        row: { origin_name, origin_lat, origin_lng, origin_url },
      }) => {
        let url;
        if (!origin_url) {
          url = `https://www.google.com/maps/search/?api=1&query=${origin_lat},${origin_lng}&zoom=20`;
        } else {
          url = origin_url;
        }
        return (
          <a
            href={url}
            target="_blank"
            style={{
              color: "white",
              fontSize: 14,
              listStyle: "none",
              textDecoration: "none",
            }}
          >
            {origin_name}
          </a>
        );
      },
    },
    {
      headerName: "DESTINO",
      field: "destination_name",
      width: 200,
      renderCell: ({
        row: {
          destination_name,
          destination_lat,
          destination_lng,
          destination_url,
        },
      }) => {
        let url;
        if (!destination_url) {
          url = `https://www.google.com/maps/search/?api=1&query=${destination_lat},${destination_lng}&zoom=20`;
        } else {
          url = destination_url;
        }
        return (
          <a
            href={url}
            target="_blank"
            style={{
              color: "white",
              fontSize: 14,
              listStyle: "none",
              textDecoration: "none",
            }}
          >
            {destination_name}
          </a>
        );
      },
    },
    {
      headerName: "NOMBRE",
      field: "fullname",
      type: "string",
      headerAlign: "left",
      align: "left",
      width: 200,
    },
    {
      headerName: "EMPRESA",
      field: "commertial_name",
      width: 200,
    },
    {
      headerName: "TIPO",
      field: "payment_type",
      width: 100,
    },
    {
      headerName: "IMPUESTO",
      field: "tax",
      width: 100,
    },
    {
      headerName: "PEAJE",
      field: "toll",
      width: 100,
    },
    {
      headerName: "PAGO TOTAL",
      field: "price_total",
      width: 100,
    },
    {
      headerName: "PAGO CONDUCTOR",
      field: "price_driver",
      width: 100,
    },
    {
      headerName: "Porcentual",
      field: "commission",
      width: 100,
    },
    {
      headerName: "CANTIDAD %",
      field: "amount",
      width: 100,
    },
    {
      headerName: "",
      field: "actions",
      width: 90,
      renderCell: ({ row: { id, order_number } }) => {
        return (
          <div>
            <Button
              color="secondary"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => {
                setUID(id);
                setAnchorEl(event.currentTarget);
              }}
            >
              OPCIONES
            </Button>
            <Menu
              id="menu-options"
              MenuListProps={{ "aria-labelledby": "fade-button" }}
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              <MenuItem
                onClick={() => {
                  handleOpenEditModal();
                  setBookingBusinessData();
                  handleClose();
                }}
              >
                VER
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  const columnsFixed = [
    { field: "index", headerName: "ID", width: 50 },
    {
      headerName: "Fijo",
      field: "fixed",
      width: 100,
    },
  ];

  const [open, setOpen] = useState(false);
  const handleModalClose = () => setOpen(false);

  const [openModalDebt, setOpenModalDebt] = useState(false);
  const handleModalDebtClose = () => setOpenModalDebt(false);

  const [isLoading, setIsLoading] = useState(false);
  const [messageSnk, setMessageSnk] = useState("");
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const vertical = "top";
  const horizontal = "center";
  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  const [value, setValue] = React.useState(null);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box m="10px">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title={driverName} subtitle="HISTORIAL DE SERVICIOS" />
            </Box>
            <Box display="grid" gap="10px">
              <Box gridColumn="span 12" gridRow="span 2">
                {bookSort ? (
                  <Box
                    m="10px 0 0 0"
                    height="100vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                    }}
                  >
                    <DataGrid
                      getRowId={(row) => row.order_number}
                      rows={bookSort}
                      columns={columns}
                      localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                      }
                    />
                  </Box>
                ) : null}
              </Box>
            </Box>

            <Modal open={openEditModal} onClose={handleCloseEditModal}>
              <Box sx={styleModal} backgroundColor={colors.primary[400]}>
                {selectBooking && (
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="h5" component="h2">
                        PEDIDO : {selectBooking.order_number}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={6} md={6}>
                      <TextField
                        value={selectBooking.commission}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="text"
                        label={"COMISION"}
                        name="payment_commission"
                        onChange={(e) => {
                          selectBooking.commission = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6} md={6}>
                      <FormControl fullWidth>
                        <InputLabel id="select-type">TIPO DE PAGO</InputLabel>
                        <Select
                          value={selectBooking.payment_type_id}
                          fullWidth
                          labelId="select-type"
                          id="payment_type"
                          onChange={(e) => {
                            selectBooking.payment_type_id = e.target.value;
                            setIgv(e.target.value);
                          }}
                          label="CONDUCTOR"
                          name="payment_type"
                        >
                          <MenuItem value={1}>EFECTIVO</MenuItem>
                          <MenuItem value={2}>CREDITO</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={3} md={6}>
                      <TextField
                        value={selectBooking.tax}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="number"
                        label={"IMPUESTO"}
                        name="tax"
                        onChange={(e) => {
                          selectBooking.tax = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3} md={6}>
                      <TextField
                        value={selectBooking.toll}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="number"
                        label={"PEAJE"}
                        name="toll"
                        onChange={(e) => {
                          selectBooking.toll = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3} md={6}>
                      <TextField
                        value={selectBooking.price_driver}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="number"
                        label={"PRECIO C."}
                        name="price_driver"
                        onChange={(e) => {
                          selectBooking.price_driver = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3} md={6}>
                      <TextField
                        value={selectBooking.price_total}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="number"
                        label={"TOTAL"}
                        name="price_total"
                        onChange={(e) => {
                          selectBooking.price_total = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Autocomplete
                        value={
                          driverStatus1 === ""
                            ? selectBooking.status
                            : driverStatus1
                        }
                        disablePortal
                        id="combo-box-driver-status"
                        onChange={(e, newValue) => {
                          if (newValue != null) setDriverStatus(newValue);
                        }}
                        name="driverStatus"
                        options={listState}
                        getOptionLabel={(option) => `${option}`}
                        renderInput={(params) => (
                          <TextField {...params} label={"ESTADO"} />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      {drivers && (
                        <Autocomplete
                          value={driverSelect}
                          disablePortal
                          id="combo-box-driver"
                          onChange={(e, newValue) => {
                            setDriverSelect(newValue);
                          }}
                          options={drivers}
                          getOptionLabel={(option) =>
                            `${option.name} ${option.lastname} ${option.brand} ${option.model} ${option.bodywork} ${option.plate} ${option.color}`
                          }
                          renderInput={(params) => (
                            <TextField {...params} label={"CONDUCTOR"} />
                          )}
                        />
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        value={selectBooking.notes}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="text"
                        label={"NOTAS"}
                        name="notes"
                        onChange={(e) => {
                          selectBooking.notes = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        value={selectBooking.notes_admin}
                        fullWidth
                        variant="outlined"
                        color="success"
                        type="text"
                        label={"NOTAS ADMIN"}
                        name="notesAdmin"
                        onChange={(e) => {
                          selectBooking.notes_admin = e.target.value;
                          setIgv(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div>
                        {advanceList.map((pay, idx) => {
                          return (
                            <Fragment key={idx}>
                              <span style={{ fontWeight: "bold" }}>
                                {pay.created_by}
                              </span>
                              {", "}
                              <span style={{ fontWeight: "bold" }}>Pago: </span>
                              {pay.amount} {pay.currency},{" "}
                              <span style={{ fontWeight: "bold" }}>
                                Fecha:{" "}
                              </span>
                              {pay.operation_date}
                              {". "}
                            </Fragment>
                          );
                        })}
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        sx={{ height: 45 }}
                        disabled={isLoading}
                        onClick={async (e) => {
                          e.preventDefault();
                          try {
                            //UPDATE los nuevos datos
                            setIsLoading(true);
                            const book = {
                              id: selectBooking.id,
                              order_number: selectBooking.order_number,
                              payment_type_id: selectBooking.payment_type_id,
                              tax: selectBooking.tax,
                              toll: selectBooking.toll,
                              driver: selectBooking.price_driver,
                              total: selectBooking.price_total,
                              commission: selectBooking.commission,
                              status:
                                driverStatus1 === ""
                                  ? selectBooking.status
                                  : driverStatus1,

                              driver_id: driverSelect
                                ? driverSelect.driver_id
                                : id,
                              vehicle_id: driverSelect
                                ? driverSelect.vehicle_id
                                : selectBooking.vehicles_id,

                              notes: selectBooking.notes,
                              notes_admin: selectBooking.notes_admin,
                            };

                            console.log(selectBooking.commertial_name);
                            if (
                              selectBooking.commertial_name == undefined ||
                              selectBooking.commertial_name == ""
                            ) {
                              await updatePaymentBookingNow("token", book);
                            } else {
                              await updatePaymentBooking("token", book);
                            }
                            snackBarDialog("DATOS ACTUALIZADOS");
                            handleCloseEditModal();
                            setIsLoading(false);
                          } catch (error) {
                            setIsLoading(false);
                            snackBarDialog(
                              "NO SE PUEDE ACTUALIZAR LOS DATOS",
                              "error",
                            );
                            console.log(error);
                            handleCloseEditModal();
                          }
                        }}
                      >
                        GUARDAR
                      </Button>
                    </Grid>

                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="error"
                        sx={{ height: 45 }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleCloseEditModal();
                        }}
                      >
                        CANCELAR
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Box>
            </Modal>

            <SnackBar
              stateSnk={stateSnk}
              vertical={vertical}
              horizontal={horizontal}
              duration={5000}
              handleClose={handleSnkClose}
              severity={severity}
              messageSnk={messageSnk}
            />
          </Box>
        </main>
      </div>
    </>
  );
};

export default DriverHistory;
